import { PATHS } from "../path/Path";
import HomePage from "../../pages/home";
import ErrorPage from "../../pages/error/ErrorPage";
import MainLayout from "../../pages/layout/MainLayout";
import OverviewBitel from "../../pages/Overview/OverviewBitel";
import OverviewMytel from "../../pages/Overview/OverviewMytel";
import OverViewHalotel from "../../pages/Overview/OverViewHalotel";
import Subasta from "../../pages/Bitel/Subasta/Subasta";
import BitelAirtime from "../../pages/Bitel/Airtime";
import HalotelAirTime from "../../pages/Halotel/Airtime/HalotelAirTime";
import Halogame from "../../pages/Halotel/Halogame/Halogame";
import Auction from "../../pages/Mytel/Auction/Auction";
import Voicemessage from "../../pages/Mytel/Voicemessage/Voicemessage";
import Login from "../../pages/Login/Login";
import RevenueUnitel from "../../pages/Unitel/Revenue/RevenueUnitel";
import VmailAirtime from "../../pages/Natcom/Vmail";
import CurrentMessage from "../../pages/Natcom/Vmail/CurrentMessage";
import MissCall from "../../pages/Natcom/Vmail/MissCall";
import Ntm from "../../pages/Natcom/Ntm";
import AirtimeNatcom from "../../pages/Natcom/Airtime";
import VmailUnitel from "../../pages/Unitel/Vmail";
import ErrorCode from "../../pages/Mytel/ErrorCode";
import VmailMytel from "../../pages/Mytel/Vmail";
import ConfigAlert from "../../pages/Config/Alert";
import MagicWheel from "../../pages/Mytel/MagicWheel/MagicWheel";
import RevenueBicagame from "../../pages/Bicagame/Revenue/RevenueBicagame";
import RevenueBicagameVina from "../../pages/BicagameVina/Revenue/RevenueBicagame";
import MovitelMagicWheel from "../../pages/Movitel/MagicWheel/MovitelMagicWheel";
import RevenueUnitelUnitelGroup from "../../pages/Unitel/Revenue/RevenueUnitelUnitelGroup";
import MathMatch from "../../pages/Mytel/MathMatch/MathMatch";
import RevenueSabayGame from "../../pages/Campuchia/SabayGame/SabayGame";

const RouterList = [
  {
    element: <MainLayout />,
    children: [
      {
        path: PATHS.HOME_PAGE,
        element: <HomePage />,
      },
      {
        path: PATHS.OVERVIEW_BITEL,
        element: <OverviewBitel />,
      },
      { path: PATHS.OVERVIEW_MYTEL, element: <OverviewMytel /> },
      { path: PATHS.OVERVIEW_HALOTEL, element: <OverViewHalotel /> },

      { path: PATHS.BITEL_SUBASTA, element: <Subasta /> },
      { path: PATHS.BITEL_AIRTIME, element: <BitelAirtime /> },

      { path: PATHS.HALOTEL_AIRTIME, element: <HalotelAirTime /> },
      { path: PATHS.HALOTEL_HALOGAME, element: <Halogame /> },

      { path: PATHS.MYTEL_AUCTION, element: <Auction /> },
      { path: PATHS.MYTEL_VOICEMESSAGE, element: <Voicemessage /> },
      { path: PATHS.VM_MYTEL, element: <VmailMytel /> },
      { path: PATHS.MYTEL_ERROR_CODE, element: <ErrorCode /> },

      { path: PATHS.UNITEL_REVENUE, element: <RevenueUnitel /> },
      { path: PATHS.UNITEL_REVENUE_UNITEL_GROUP, element: <RevenueUnitelUnitelGroup /> },
      { path: PATHS.LOGIN, element: <Login />, isHidden: true },
      // { path: PATHS.VMAIL_NTM_AIRTIME, element: <VmailAirtime /> },
      { path: PATHS.NATCOM_VMAIL_CURRENT_MESSAGE, element: <CurrentMessage /> },
      { path: PATHS.NATCOM_VMAIL_MISS_CALL, element: <MissCall /> },
      { path: PATHS.NATCOM_NTM, element: <Ntm /> },
      { path: PATHS.NATCOM_AIRTIME, element: <AirtimeNatcom /> },

      { path: PATHS.VMAIL_UNITEL, element: <VmailUnitel /> },

      { path: PATHS.CONFIG_ALERT, element: <ConfigAlert /> },
      { path: PATHS.MAGIC_WHEEL, element: <MagicWheel /> },
      { path: PATHS.MATH_MATCH, element: <MathMatch /> },
      {
        path: PATHS.MOVITEL_MAGIC_WHEEL, element: <MovitelMagicWheel />
      },

      { path: PATHS.BICAGAME, element: <RevenueBicagame /> },
      { path: PATHS.BICAGAME_VINA, element: <RevenueBicagameVina /> },
      { path: PATHS.CAMPUCHIA_SABAY_GAME, element: <RevenueSabayGame /> },

    ],
    errorElement: <ErrorPage />,
  },
];
export default RouterList;
